
import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 dark:bg-gray-900 border-t border-gray-100 dark:border-gray-800">
      <div className="container mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex flex-col items-center md:items-start">
            <div className="flex items-center gap-2 text-xl font-display font-semibold mb-4">
            <img 
              src="https://sooovuvamgyafqsqehbo.supabase.co/storage/v1/object/public/images/logo.png" 
              alt="BlueTech Logo" 
              className="w-6 h-6"
              width="24"
              height="24"
              loading="lazy"
            />
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-primary to-accent">BlueTech</span>
            </div>
            
            <p className="text-muted-foreground text-center md:text-left dark:text-gray-400">
              {t('footer_description')}
            </p>
          </div>
          
          <div className="flex items-center">
            <Link to="/adatkezeles" className="text-muted-foreground hover:text-primary transition-colors dark:text-gray-400 dark:hover:text-primary">
              {t('privacy_policy_link')}
            </Link>
          </div>
        </div>
        
        <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-800">
          <p className="text-center text-sm text-muted-foreground dark:text-gray-400">
            {t('copyright').replace('{year}', currentYear.toString())}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
